import type { VideoPlaylistState } from './slices';
import { filtersSlice, videosSlice } from './slices';
import type { VideoPlaylistOptions } from './types';

import { getOptionsProvider } from '@shared/OptionsProvider';
import { zustandStoreFactory } from '@shared/zustandStoreFactory';

export const {
  Provider: VideoPlaylistProvider,
  useStore: useVideoPlaylistStore,
  createStore: createVideoPlaylistStore,
} = zustandStoreFactory<VideoPlaylistState>(
  (...args) => ({
    ...videosSlice(...args),
    ...filtersSlice(...args),
  }),
  'VideoPlaylist',
);

export const { OptionsProvider: VideoPlaylistOptionsProvider, useOptions: useVideoPlaylistOptions } =
  getOptionsProvider<VideoPlaylistOptions>();
